export const SET_PICTURE = 'cover_picture_editor/SET_PICTURE'
export const SET_BUSY = 'cover_picture_editor/SET_BUSY'
export const SET_MODAL_OPEN = 'cover_picture_editor/SET_MODAL_OPEN'
export const SET_MODAL_PICTURE = 'cover_picture_editor/SET_MODAL_PICTURE'
